import { AnimateBox } from '../../components/animate-box'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'

import type { PageContent } from '../../pageContents'

export interface ProductsListProps {
  data: PageContent[]
  routerName: string
}

const bannerUrl = `${STATIC_OBS_URL}/website/home/products/banner.png?1`

export const ProductsList = (props: ProductsListProps) => {
  const { data } = props
  return (
    <Wrap className='products-list'>
      <div className='public-banner-box'>
        <div className='mask' style={{ backgroundImage: `url(${bannerUrl})` }} />
        <AnimateBox tagName='h2'>产品中心</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          取得ISO 26262认证，覆盖系统开发的全生命周期，高效易用、软硬结合一体，打造一体化工具
        </AnimateBox>
      </div>
      <div className='wrap'>
        <div className='title-box'>
          <h2>我们的核心产品</h2>
          <p>GCKontrol-GCAir基于模型的系统设计工具链</p>
        </div>

        <div className='list-box'>
          <ul>
            {data.map((item, i) => {
              const { name, descriptions, id, thumbnail } = item
              const url = `/products/${id}`
              const dely1 = i % 2 == 0 ? 0 : 0.5
              const dely2 = i % 2 == 1 ? 0 : 0.5

              return (
                <li className='item' key={url}>
                  <div className='box'>
                    <AnimateBox animateDelay={dely1} className='group-a'>
                      <h3>
                        <a href={url}>{name}</a>
                      </h3>
                      <p>{descriptions}</p>
                      <a className='look-more-blue' href={url}>
                        了解详情
                      </a>
                    </AnimateBox>
                    <AnimateBox animateDelay={dely2} className='group-b'>
                      <div className='img' style={{ backgroundImage: `url(${thumbnail})` }} />
                    </AnimateBox>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </Wrap>
  )
}
